"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.eventTypes.conversation_analysis': 'Analiza Rozmowy',
    'webhook.eventTypes.avatar_updated': 'Awatar Zaktualizowany',
    'webhook.eventTypes.avatar_deleted': 'Awatar Usunięty',
    'webhook.eventTypes.avatar_test_complete': 'Test Awatara Zakończony',
    'webhook.eventTypes.knowledge_added': 'Wiedza Dodana',
    'webhook.eventTypes.knowledge_removed': 'Wiedza Usunięta',
    'webhook.eventTypes.knowledge_notify': 'Edycja wiedzy',
};
